<template>
    <div class="slide">

        <go-back />

        <div class="slide-container">

            <div class="question bigger">
                Are you <span>married</span> or <span>single</span>?
            </div>

            <div class="answer answer-col">
                <span class="alternative" @click="next(true)">Married</span>
                <span class="alternative" @click="next(false)">Single</span>
            </div>

        </div>

    </div>
</template>

<script>
    import GoBack from "./GoBack";

    export default {
        name: 'MarriedSingle',
        components: {
            GoBack
        },
        methods: {
            next( married ) {
                this.$store.commit('individuals/addRemovePersonTwo', married);
                this.$router.push({ name: 'Name' })
            }
        }
    }
</script>
